import React from 'react';
import { Helmet } from 'react-helmet-async';

interface MetaTagsProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
}

export function MetaTags({ 
  title = 'rendezvous - Curated Experiences',
  description = 'Discover extraordinary moments through curated experiences that inspire, transform, and connect.',
  image = 'https://rendezvouswebsite.b-cdn.net/DSCF9542.JPG',
  url = 'https://letsrendezvous.co'
}: MetaTagsProps) {
  // Ensure URLs are absolute
  const absoluteUrl = url.startsWith('http') ? url : `https://letsrendezvous.co${url}`;
  const absoluteImageUrl = image.startsWith('http') ? image : `https://letsrendezvous.co${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={absoluteUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={absoluteImageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={absoluteUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={absoluteImageUrl} />
    </Helmet>
  );
}